import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { ScrollArea } from '@/components/ui/scroll-area'
import { DailyRateRow } from './DailyRateRow'
import type { DailyPriceBreakdown } from './price-calculator-types'

interface PriceCalculatorBreakdownProps {
  days: DailyPriceBreakdown[]
}

export function PriceCalculatorBreakdown({ days }: PriceCalculatorBreakdownProps) {
  if (days.length === 0) {
    return (
      <div className="flex items-center justify-center h-full text-sm text-muted-foreground">
        Select dates to see daily pricing breakdown
      </div>
    )
  }

  return (
    <ScrollArea className="max-h-[400px]">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="text-xs w-[110px]">Day</TableHead>
            <TableHead className="text-xs w-[130px]">Occupancy</TableHead>
            <TableHead className="text-xs w-[140px]">Factors</TableHead>
            <TableHead className="text-xs text-right w-[80px]">Rate</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {days.map((day) => (
            <DailyRateRow key={day.date} day={day} />
          ))}
        </TableBody>
      </Table>
    </ScrollArea>
  )
}
